<template>
    <div>
        <!--class="grid with-grid-lines page--light is-chrome"-->
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
        <div style="padding-left:10%">
            <template v-if="!cargando">
                <infoCliente></infoCliente>
                <!-- Se elimina la posibilidad de suscripción para particulares inscritos a petición de Zeleris
                <infoSuscripcion></infoSuscripcion>
            -->
                <infoReparaciones></infoReparaciones>
            </template>
            </div>
            <pie></pie>
        </div>
</template>

<script>
let instanciaVue = {
        components: {
            encabezado: () => import("@/components/newEncabezado"),
            breadcrum: () => import("@/components/breadcrum"),
            infoCliente: () => import("@/components/paginaInfoCliente/infoCliente"),
            //infoSuscripcion: () => import("@/components/paginaInfoCliente/infoSuscripcion"),
            infoReparaciones: () => import("@/components/paginaInfoCliente/infoReparaciones"),
            pie: () => import('@/components/newPie')
        },
        data: () => ({
            cargando: false,
            name: 'info-clientes',
            texto: 'En esta página podrás revisar tus datos, gestionar tus suscripciones y crear reparaciones para tus dispositivos disfrutando de las ventajas que las suscripciones te ofrecen',
            titulo: 'Página del cliente',
        }),
        methods: {
            //recargarPagina() {
            //    console.log("recargarPagina", recargarPasarela)
            //    if (recargarPasarela) {
            //        router.go(router.currentRoute)
            //        document.body.scrollTop = 0;
            //        document.documentElement.scrollTop = 0;
            //    }
            //},
            redoLogin(loginData) {
                this.$API.loginCliente(loginData, false).then((response) => {
                    if (response != "") {
                        this.$bus.login = true
                        this.$bus.datosUsuario = response.datos
                    }
                    this.cargando = false
                });
            },
        },
        created() {
            //localstorage
            let login = window.localStorage.getItem('login')
            let loginData = window.localStorage.getItem('loginData')
            if (!this.$bus.login && login != null && loginData != null) {
                this.cargando = true
                this.redoLogin(JSON.parse(loginData))
            } else
                if (!this.$bus.login) this.$router.push("/particularCR");

            this.$bus.getCodigosPostales()
        }
    }

    export default instanciaVue
</script>